import { gql } from "@apollo/client";

export const GET_DETALLE_LIQUIDACION = gql`
    query detalleLiquidacion(
        $idEvaluacion: Int!
        $idEvaluacionProfesional: Int!
        $idProfesional: Int!
        $mes: Int!
        $anio: Int!
        $liquidacionFinal: Boolean
    ) {
        detalleLiquidacion(
            idEvaluacion: $idEvaluacion
            idEvaluacionProfesional: $idEvaluacionProfesional
            idProfesional: $idProfesional
            mes: $mes
            anio: $anio
            liquidacionFinal: $liquidacionFinal
        ) {
            success
            error
            valorEsperado {
                tipo
                cantidad
                importe
                tramo
                total
                horasTotales
            }
        }
    }
`;